import axios from 'axios';

export default {
  namespaced: true,
  state: {
    items: [], 
    listed: false,
  },
  mutations: {
    SET_ITEMS(state, items) {
      state.items = items;
    },
    SET_LISTED(state, value) {
      state.listed = value;
    }
  },
  actions: {
    async fetchList({ commit, rootState }) {

        const apiPreUrl = rootState.url.apiPreUrl;

          const user = JSON.parse(sessionStorage.getItem('user'));
          if (!user || !user.token) {         
            return;
          }
        
          const token = user.token;
        
          try {
                const response = await axios({
                method: 'POST',
                // url: process.env.VUE_APP_API_PRE_URL+'/api/v1.0/navi',
                url: apiPreUrl+'/api/v1.0/navi',
                headers: {
                    Authorization: `Bearer ${token}`
                }
              });

              const language = rootState.language.selectedLanguage;
              // const translationsResponse = await axios.get(process.env.VUE_APP_API_PRE_URL + `/api/translation/${language}`);
              const translationsResponse = await axios.get( apiPreUrl + `/api/translation/${language}`);
              const translations = translationsResponse.data;
              
              const updateItems = (items, translations) => {
                items.forEach((item) => {
                  if (item.title && translations[item.title]) {
                    item.title = translations[item.title];
                  }
                  if (item.children) {
                    updateItems(item.children, translations);
                  }
                });
              };
              updateItems(response.data, translations);

              commit('SET_ITEMS', response.data);
              commit('SET_LISTED', true);

          } catch (error) {
              console.error(error);
        }
    },
  },
  getters: {
      items: state => state.items,
      listed: state => state.listed,
  },
}
